import { SpreadsheetCommands } from 'editor/commands/SpreadsheetCommands'
import { IEditorPlugin } from '../EditorService'
import { SpreadsheetElementDef } from '../elements/SpreadsheetElement'

export const SpreadsheetPlugin: IEditorPlugin = {
  setup(editor) { return editor },
  elements: {
    'spreadsheet': SpreadsheetElementDef,
  },
  commands: [
    { title: 'Add Spreadsheet', handler: (e, s) => SpreadsheetCommands.addSpreadsheet(s) },
  ],
}
